module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nv-empty",
    class: {
      'nv-empty--visible': _vm.visible
    }
  }, [_c('div', {
    staticClass: "nv-empty-icon"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.icon
  })]), _vm._v(" "), _c('p', {
    staticClass: "nv-empty-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.hint) ? _c('p', {
    staticClass: "nv-empty-hint"
  }, [_vm._v(_vm._s(_vm.hint))]) : _vm._e(), _vm._v(" "), (_vm.actionTo) ? _c('router-link', {
    staticClass: "btn btn-primary btn-sm nv-empty-action",
    attrs: {
      "to": _vm.actionTo
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.actionLabel) + "\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-05951a28","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NvEmptyState.vue
// module id = lS85
// module chunks = 1